import React from "react";
import { useHistory } from "react-router";
import Flash from "../layout/Flash";
import * as API from "../api";
import * as CONST from "../Constants";
import PcpLocationsList from "./dashboard/PcpLocationsList";

export default function PcpElectionPage(props) {
  const history = useHistory();
  const [flash, setFlash] = React.useState(null);

  return (
    <div>
      {flash && <Flash flash={flash} handleClose={() => setFlash(null)} />}

      <PcpLocationsList
        selectPcp={async (p) => onSubmitPcp(p)}
        cancel={() => history.push("/patient_portal/dashboard")}
      />
    </div>
  );
}
